import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AnchorLink from 'react-anchor-link-smooth-scroll';

import { IntlContext } from '../../Providers/Intl';

import { InternalStyledLink, ExternalStyledLink } from './styles';

const Link = ({
  id,
  className,
  children,
  to,
  ariaLabel,
  queryString,
  external,
  noSpan,
  onClick,
}) => {
  const { intl } = useContext(IntlContext);
  const localePrefix = intl ? `/${intl.path}` : '';

  const isJumpLink = /^#/.test(to);
  const isInternal = external ? false : /^\/(?!\/)/.test(to);
  const isSpecialLink = /\btel:\b|\bmailto:\b/.test(to);
  const child = noSpan ? children : <span>{children}</span>;

  const setParameters = string => {
    if (queryParameters.length > 0) {
      const queryParameter = queryParameters.join('&');
      return `${string}/?${queryParameter}`;
    }
    return string;
  };

  const [queryParameters, setQueryParameters] = useState([]);
  // * When the page first mounts we check for a filterQuery in the url
  useEffect(() => {
    if (typeof document !== 'undefined' && queryString) {
      const params = new URL(document.location).searchParams;
      const queries = queryString.split(',');
      queries.forEach(query => {
        const key = query.trim();
        const queryParam = params.get(key);
        if (queryParam) {
          setQueryParameters(prevState => {
            const newState = [...prevState, `${key}=${queryParam}`];
            return newState;
          });
        }
      });
    }
  }, []);

  if (isJumpLink) {
    return (
      <AnchorLink
        id={id}
        className={className}
        href={to}
        aria-label={ariaLabel}
      >
        {child}
      </AnchorLink>
    );
  }
  return isInternal ? (
    <InternalStyledLink
      id={id}
      className={className}
      to={`${localePrefix}${setParameters(to)}`}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {child}
    </InternalStyledLink>
  ) : (
    <ExternalStyledLink
      id={id}
      className={className}
      href={external ? `${localePrefix}${setParameters(to)}` : to}
      aria-label={ariaLabel}
      isSpecialLink={isSpecialLink}
    >
      {child}
    </ExternalStyledLink>
  );
};

Link.propTypes = {
  id: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  to: PropTypes.string,
  ariaLabel: PropTypes.string,
  external: PropTypes.bool,
  noSpan: PropTypes.bool,
  queryString: PropTypes.string,
  onClick: PropTypes.func,
};

Link.defaultProps = {
  id: null,
  className: null,
  to: '/',
  ariaLabel: null,
  external: false,
  noSpan: false,
  queryString: null,
  onClick: null,
};

export default Link;
